import { useState, useEffect, useCallback } from 'react';

const useMousePosition = () => {
  const [mouseX, setMouseX] = useState(0);
  const [mouseY, settMouseY] = useState(0);

  const updatePosition = useCallback((event: MouseEvent) => {
    const x = event.clientX;
    const y = event.clientY;
    setMouseX(x);
    settMouseY(y);
  }, []);

  useEffect(() => {
    document.addEventListener('mousemove', updatePosition);
    return () => window.removeEventListener('mousemove', updatePosition);
  }, [updatePosition]);

  return { mouseX, mouseY };
};

export default useMousePosition;
